import ResourceLink from 'models/resourceLink';
import { IDriveItem } from '../../services/Graph/SharepointInterfaces';
import DirectoryExplorer, { ParentFolderInformation } from './DirectoryExplorer';

interface ISharepointFilePicker {
  invalidAuthToken: () => void;
  onSelect: (files: IDriveItem[] | undefined) => void;
  parentFolder?: ParentFolderInformation;
  viewMode?: boolean;
  existingLinks?: ResourceLink[];
  linkToEdit?: ResourceLink;
  singleSelect?: boolean;
  disabled?: boolean;
  setCurrentDriveId?: (id: string | undefined) => void;
}

const SharepointFilePicker = (props: ISharepointFilePicker) => {
  return (
    <DirectoryExplorer
      parentFolder={props.parentFolder}
      invalidAuthToken={props.invalidAuthToken}
      onSelectItems={(items?: IDriveItem[]) => {
        props.onSelect(items);
      }}
      viewMode={props.viewMode}
      existingLinks={props.existingLinks}
      linkToEdit={props.linkToEdit}
      singleSelect={props.singleSelect}
      disabled={props.disabled}
      setCurrentDriveId={props.setCurrentDriveId}
    />
  );
};

export default SharepointFilePicker;
